<template>
  <div v-loading="loading">
    <!-- Table -->
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="dialogVisible = true">{{$t("general.add")}}</el-button>
        <!-- <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="JPDate()">JPDate</el-button> -->
      </el-form-item>
    </el-form>

    <el-table :data="tableData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('companyInfo.name')" align="center" width="200">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-button type="text" @click="handleDetails(scope.$index, scope.row)">{{ scope.row.name1 }}</el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('companyInfo.addressT')" align="center" width="330">
        <template slot-scope="scope">
          <span>{{ scope.row.address0 }}</span>
          <span>{{ scope.row.address1 }}</span>
          <span>{{ scope.row.address2 }}</span>
          <span>{{ scope.row.address3 }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('companyInfo.capital')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.capital }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('companyInfo.postal_code')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.postalCode }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('companyInfo.establishment_date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.establishmentDate }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">{{$t("general.edit")}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">{{$t("general.delete")}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Detailed Info -->

    <el-dialog :title="$t('companyInfo.detail')" :append-to-body="true" :visible.sync="dialogDetails" width="75%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="200px" class="demo-ruleForm" size="mini">
        <el-collapse v-model="activeNames" @change="handleChange" accordion>
          <el-collapse-item :title="$t('companyInfo.office_info')" name="1" class="title">
            <el-row style="margin-left: 50px">
              <el-col :span="12">
                <div>
                  <el-form-item class="label-style" :label="$t('companyInfo.name1')">
                    :&emsp;{{ruleForm.name1}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.chairman')">
                    :&emsp;{{ruleForm.chairman}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.company_code')">
                    :&emsp;{{ruleForm.companyCode}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.establishment_date')">
                    :&emsp;{{ruleForm.establishmentDate}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.capital')">
                    :&emsp;{{ruleForm.capital}}&nbsp;万円
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.emp_amount')">
                    :&emsp;{{ruleForm.empAmount}} &emsp;{{$t("empIns1.person")}}
                  </el-form-item>

                </div>
              </el-col>

              <el-col :span="12">
                <div>

                  <el-form-item class="label-style" :label="$t('companyInfo.name_kn1')">
                    :&emsp;{{ruleForm.nameKn1}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.chairman_ka')">
                    :&emsp;{{ruleForm.chairmanKa}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.chairman_code')">
                    :&emsp;{{ruleForm.chairmanCode}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.end_date')">
                    :&emsp;{{ruleForm.endDate}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.business_overview')">
                    :&emsp;{{ruleForm.basicBusinessOverview}}
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('companyInfo.address')" name="2">
            <el-row style="margin-left: 50px">
              <el-col :span="24">
                <el-form-item class="label-style" :label="$t('companyInfo.address')">
                  :&emsp; 〒 {{ruleForm.postalCode}}　
                  &nbsp;{{ruleForm.address1}}
                  &nbsp;{{ruleForm.address2}}
                  &nbsp;{{ruleForm.address3}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item class="label-style" label="所在地（フリガナ）">
                  :&emsp; 〒 {{ruleForm.postalCode}}　
                  &nbsp;{{ruleForm.addressFrgn1}}
                  &nbsp;{{ruleForm.addressFrgn2}}
                  &nbsp;{{ruleForm.addressFrgn3}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 50px">
              <el-col :span="12">
                <el-form-item class="label-style" :label="$t('companyInfo.tel')">
                  :&emsp;{{ruleForm.tel}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 50px">
              <el-col :span="12">
                <el-form-item class="label-style" label="FAX">
                  :&emsp;{{ruleForm.fax}}
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('companyInfo.salary')" name="3">
            <el-row style="margin-left: 50px">
              <el-col :span="12">
                <div>
                  <el-form-item class="label-style" :label="$t('companyInfo.salary_close_day')">
                    :&emsp;{{ruleForm.salaryCloseDay}} &nbsp;{{$t("empIns1.day")}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.tax_office')">
                    :&emsp;{{ruleForm.taxOffice}}
                  </el-form-item>

                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item class="label-style" :label="$t('companyInfo.salary_day')">
                    :&emsp;{{ruleForm.salaryMonth}}&nbsp;{{$t("empIns1.month")}}
                    &emsp;&emsp;{{ruleForm.salaryDay}}&nbsp;{{$t("empIns1.day")}}
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="24">
                <el-form-item label="給与形態" prop="kyuyo_month" class="label">
                  :&emsp;
                  <span v-if="ruleForm.kyuyoMonth === true">月給</span>&nbsp;
                  <span v-if="ruleForm.kyuyoDay === true">日給</span>&nbsp;
                  <span v-if="ruleForm.kyuyoDayMonth === true">日給月給</span>&nbsp;
                  <span v-if="ruleForm.kyuyoBuai === true">歩合給</span>&nbsp;
                  <span v-if="ruleForm.kyuyoJikan === true">時間給</span>&nbsp;
                  <span v-if="ruleForm.kyuyoNenpo === true">年俸制</span>&nbsp;&nbsp;&nbsp;
                  <span v-if="ruleForm.kyuyoOther === true">その他：</span>
                  <span v-if="ruleForm.kyuyoOther === true">{{ruleForm.kyuyoOtherInput}}</span>
                </el-form-item>
                <el-form-item label="諸手当の種類" prop="kyuyoMonth" class="label">
                  :&emsp;
                  <span v-if="ruleForm.teateKazoku === true">家族手当</span>&nbsp;
                  <span v-if="ruleForm.teateJutaku === true">住宅手当</span>&nbsp;
                  <span v-if="ruleForm.teateYakutsuke === true">役付手当</span>&nbsp;
                  <span v-if="ruleForm.teateTsukin === true">通勤手当</span>&nbsp;
                  <span v-if="ruleForm.teateSeikin === true">精勤手当</span>&nbsp;
                  <span v-if="ruleForm.teateZangyo === true">残業手当</span>&nbsp;&nbsp;&nbsp;
                  <span v-if="ruleForm.teateOther === true">その他：</span>
                  <span v-if="ruleForm.teateOther === true">{{ruleForm.teateOtherInput}}</span>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="事業所の所定労働時間" prop="taxOffice" class="label">
                  :&emsp;
                  1ヶ月：&nbsp;{{ruleForm.shoteiDay}}&nbsp;日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  1週：&nbsp;{{ruleForm.shoteiHour}}&nbsp;時間&nbsp;{{ruleForm.shoteiMinute}}分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  1日：&nbsp;{{ruleForm.shoteiDayHour}}&nbsp;時間&nbsp;{{ruleForm.shoteiDayMinute}}分
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="雇用保険について" name="4">
            <el-row style="margin-left: 50px">
              <el-col :span="12">
                <div>
                  <el-form-item class="label-style" :label="$t('companyInfo.emp_insurance_code')">
                    :&emsp;{{ruleForm.emp_insuranceCode}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.labor_insurance_code')">
                    :&emsp;{{ruleForm.laborInsuranceCode}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.ins_amount')">
                    :&emsp;{{ruleForm.insAmount}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.business_overview')">
                    :&emsp;{{ruleForm.businessOverview}}
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item class="label-style" :label="$t('companyInfo.begin_day_emp')">
                    :&emsp;{{ruleForm.beginDayEmp}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.begin_day_labor')">
                    :&emsp;{{ruleForm.beginDayLabor}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.insamount_day')">
                    :&emsp;{{ruleForm.insamountDay}}
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item title="社会保険について" name="5">
            <el-row style="margin-left: 50px">
              <el-col :span="12">
                <div>
                  <el-form-item class="label-style" :label="$t('companyInfo.health_ins_code')">
                    :&emsp;{{ruleForm.healthInsCode}}
                  </el-form-item>

                  <el-form-item class="label-style" :label="$t('companyInfo.emp_amount')">
                    :&emsp;{{ruleForm.empAmount}}
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item class="label-style" :label="$t('companyInfo.health_company_num')">
                    :&emsp;{{ruleForm.healthCompanyNum}}
                  </el-form-item>

                  <el-form-item class="label-style" label="社会保険に加入する従業員数">
                    :&emsp;{{ruleForm.empHokenAmount}}
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item title="社会保険に加入しない従業員について" name="6">
            <el-row style="margin-left: 50px">
              <el-col :span="24">
                <div>
                  <el-form-item class="label-style" label="役員人数">
                    :&emsp;{{ruleForm.yakuinNoHoken}}&nbsp;人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    報酬：&nbsp;&nbsp;{{ruleForm.yakuinHoshu}}&nbsp;&nbsp;&nbsp;&nbsp;
                    常勤：&nbsp;&nbsp;{{ruleForm.yakuinJokin}}&nbsp;人&nbsp;&nbsp;&nbsp;&nbsp;
                    非常勤：&nbsp;&nbsp;{{ruleForm.yakuinNoJokin}}&nbsp;人
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row style="margin-left: 50px">
              <el-col :span="24">
                <div>
                  <el-form-item class="label-style" label="嘱託.非常勤人数">
                    :&emsp;{{ruleForm.shokutakuNoJokin}}&nbsp;人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    1月：&nbsp;&nbsp;&nbsp;{{ruleForm.shokutakuNoJokin_day}}&nbsp;日ぐらい&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    1日：&nbsp;&nbsp;&nbsp; {{ruleForm.shokutakuNoJokinTime}}&nbsp;時間ぐらい
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row style="margin-left: 50px">
              <el-col :span="24">
                <div>
                  <el-form-item class="label-style" label="パート人数">
                    :&emsp;{{ruleForm.pato}}&nbsp;人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    1月：&nbsp;&nbsp;&nbsp;{{ruleForm.patoDay}}&nbsp;日ぐらい&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    1日：&nbsp;&nbsp;&nbsp; {{ruleForm.patoTime}}&nbsp;時間ぐらい
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row style="margin-left: 50px">
              <el-col :span="24">
                <div>
                  <el-form-item class="label-style" label="アルバイト人数">
                    :&emsp;{{ruleForm.arubaito}}&nbsp;人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    1月：&nbsp;&nbsp;&nbsp;{{ruleForm.arubaitoDay}}&nbsp;日ぐらい&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    1日：&nbsp;&nbsp;&nbsp;&nbsp;{{ruleForm.arubaitoTime}}&nbsp;時間ぐらい
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()" type="primary" size="medium">{{$t("general.close")}}</el-button>
      </span>
    </el-dialog>

    <!-- Add Info -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="90%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="270px" class="demo-ruleForm" size="mini">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item :title="$t('companyInfo.office_info')" name="1" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.name1')" prop="name1" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name1" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.name1P')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.chairman')" prop="chairman" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.chairman" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.chairmanP')"></el-input>
                    <el-popover placement="top-start" title="記入方法" width="200" trigger="hover" content="代表者氏名を全角で入力してください。姓と名前の間に全角スペースを入れてください。外国籍の氏名が漢字表記ではない場合、全角アルファベット（大文字）もしくは全角カタカナで入力してください。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.chairman_code')" prop="chairmanCode" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.chairmanCode" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.company_code_example')"></el-input>
                    <el-popover placement="top-start" title="法人番号とは" width="200" trigger="hover" content="検査用数字（1桁） ＋ 会社法人等番号（12桁）を合わせた数字13桁からなる番号の事です。https://www.houjin-bangou.nta.go.jp/">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('companyInfo.establishment_date')" prop="establishmentDate" style="margin-left:50px">
                    <el-date-picker @change="DateInput11(ruleForm.establishmentDate)" v-model="ruleForm.establishmentDate" size="mini" value-format="yyyy-MM-dd" style="margin-right:10px;width:185px" placeholder="例:1996-3-20" type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput11 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('companyInfo.establishment_date')" prop="establishmentDate" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput12(ruleForm.establishmentDate)" v-model="ruleForm.establishmentDate" size="mini" style="margin-right:0px;width:185px" placeholder="例:H8/3/20" clearable=""></el-input>&nbsp;&nbsp;
                    <span> {{ dateForm.DateInput12 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('companyInfo.end_date')" prop="endDate" style="margin-left:50px">
                    <el-date-picker @change="DateInput21(ruleForm.endDate)" v-model="ruleForm.endDate" size="mini" value-format="yyyy-MM-dd" style="margin-right:10px;width:185px" placeholder="例:1996-3-20" type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput21 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('companyInfo.end_date')" prop="endDate" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput22(ruleForm.endDate)" v-model="ruleForm.endDate" size="mini" style="margin-right:0px;width:185px" placeholder="例:H8/3/20" clearable=""></el-input>&nbsp;&nbsp;
                    <span> {{ dateForm.DateInput22 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.capital')" prop="capital" style="margin-left:50px">
                    <el-input @change="handleToMoney" prefix-icon="el-icon-edit" v-model="ruleForm.capital" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.capital_example')"></el-input>&nbsp; 万円
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.name_kn1')" prop="nameKn1">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.nameKn1" size="mini" style="width:280px" :placeholder="$t('companyInfo.name_kn1P')"></el-input>
                    <el-popover placement="top-start" title="記入方法" width="200" trigger="hover" content="次のとおり、略して記入してください。株式会社の場合 ➡ ｢カ 」有限会社の場合 ➡ 「ユ」合名会社の場合 ➡ 「メ」合資会社の場合➡ 「シ」それ以外の法人の場合 ➡ そのまま記入">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.chairman_ka')" prop="chairmanKa">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.chairmanKa" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.chairman_kaP')"></el-input>
                    <el-popover placement="top-start" title="記入方法" width="200" trigger="hover" content="代表者氏名を全角で入力してください。姓と名前の間に全角スペースを入れてください。外国籍の氏名が漢字表記ではない場合、全角アルファベット（大文字）もしくは全角カタカナで入力してください。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <ei-col :span="24">
                <el-form-item :label="$t('companyInfo.business_overview')" prop="basicBusinessOverview" style="margin-left:50px">
                  <el-select @change="businessOverviewChanged" v-model="ruleForm.basicBusinessOverview" size="mini" style="margin-right:0px;width:280px" placeholder="入力してください" filterable clearable>
                    <el-option-group :class="groupBg" v-for="group in basicBusinessOverview" :key="group.label" :label="group.label">
                      <el-option :disabled="item.disabled" v-for="item in group.options" :key="item.value" :label="item.value" :value="item.value"></el-option>
                    </el-option-group>
                  </el-select>
                  <el-link type="primary" class="el-icon-info" :underline="false" href="https://www.chukei-news.co.jp/publication/chubunenkan-regist/type.pdf" target="_blank">業種一覧表</el-link>
                </el-form-item>
              </ei-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('companyInfo.address')" name="2">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('companyInfo.postal_code')" prop="postalCode" style="margin-left:50px">
                  <el-input @change="searchLocation" prefix-icon="el-icon-edit" v-model="ruleForm.postalCode" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.postal_code_example')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('companyInfo.address0')" prop="address0" style="margin-left:50px">
                  <el-select @change="address0Changed" v-model="ruleForm.address0" size="mini" style="margin-right:70px;width:280px" placeholder="選択">
                    <el-option v-for="item in locationList" :key="item.id" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.address1')" prop="address1" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address1" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.city')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.address2')" prop="address2" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address2" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.street')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('companyInfo.address3')" prop="address3" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address3" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.building')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.tel')" prop="tel" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.tel" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.tel_example')"></el-input>
                  <el-popover placement="top-start" title="電話番号の書き方" width="200" trigger="hover" content="半角数字で入力してください。市外局番と市内局番、市内局番と加入者番号の間にハイフン（－）を記入してください。">
                    <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                  </el-popover>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('companyInfo.address_frgn0')" prop="addressFrgn0">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.addressFrgn0" size="mini" style="margin-right:10px;width:280px" :placeholder="$t('companyInfo.address_frgn0')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.address_frgn1')" prop="addressFrgn1">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.addressFrgn1" size="mini" style="margin-right:10px;width:280px" :placeholder="$t('companyInfo.city')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.address_frgn2')" prop="addressFrgn2">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.addressFrgn2" size="mini" style="margin-right:10px;width:280px" :placeholder="$t('companyInfo.street')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('companyInfo.address_frgn3')" prop="addressFrgn3">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.addressFrgn3" size="mini" style="margin-right:10px;width:280px" :placeholder="$t('companyInfo.building')"></el-input>
                </el-form-item>
                <el-form-item label="FAX" prop="fax">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.fax" size="mini" style="margin-right:0px;width:280px" placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('companyInfo.salary')" name="3">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.salary_close_day')" prop="salaryCloseDay" class="label" style="margin-left:50px">
                    <el-select :placeholder="$t('general.select')" v-model="ruleForm.salaryCloseDay" clearable style="margin-left:0px;width:280px" size="mini">
                      <el-option v-for="item in days" :key="item.daysId" :label="item.name" :value="item.name"></el-option>
                    </el-select> &nbsp;{{$t("empIns1.day")}}
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.tax_office')" prop="taxOffice" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.taxOffice" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.tax_officeP')"></el-input>
                    <el-popover placement="top-start" title="管轄の税務署とは" width="200" trigger="hover" content="所属する納税地により管轄している税務署が決められています。ご不明の場合には下記URLよりご確認下さい：https://www.nta.go.jp/about/organization/access/map.html">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.salary_day')" prop="salaryDay" class="label">
                    <el-select v-model="ruleForm.salaryMonth" clearable style="width: 110px" size="mini" :placeholder="$t('general.select')">
                      <el-option v-for="item in salaryMonths" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    &nbsp;{{$t("empIns1.month")}}&nbsp;
                    <el-select :placeholder="$t('general.select')" v-model="ruleForm.salaryDay" clearable style="width:110px" size="mini">
                      <el-option v-for="item in salaryDays" :key="item.daysId" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                    &nbsp;{{$t("empIns1.day")}}
                  </el-form-item>

                  <el-form-item prop="taxOffice" class="label">
                    <span></span>
                    <br>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="16">
                <el-form-item label="給与形態" prop="kyuyoMonth" class="label" style="margin-left:50px">
                  <el-checkbox style="margin-right:60px" v-model="ruleForm.kyuyoMonth" size="mini">月給</el-checkbox>
                  <el-checkbox style="margin-right:60px" v-model="ruleForm.kyuyoDay" size="mini">日給</el-checkbox>
                  <el-checkbox style="margin-right:60px" v-model="ruleForm.kyuyoDay_month" size="mini">日給月給</el-checkbox>
                  <el-checkbox style="margin-right:46px" v-model="ruleForm.kyuyoBuai" size="mini">歩合給</el-checkbox>
                  <el-checkbox style="margin-right:46px" v-model="ruleForm.kyuyoJikan" size="mini">時間給</el-checkbox>
                  <el-checkbox style="margin-right:46px" v-model="ruleForm.kyuyoNenpo" size="mini">年俸制</el-checkbox>
                  <el-checkbox style="margin-right:36px" v-model="ruleForm.kyuyoOther" size="mini">{{$t("healthIns1.other")}}</el-checkbox>
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.kyuyoOtherInput" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.other')" v-if="ruleForm.kyuyoOther === true"></el-input>
                  <!-- <el-button class="el-icon-info" type="text" @click="otherAllowranceHint" v-if="ruleForm.kyuyoOther === true"></el-button> -->
                </el-form-item>

                <el-form-item label="諸手当の種類" prop="kyuyoMonth" class="label" style="margin-left:50px">
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateKazoku" size="mini">家族手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateJutaku" size="mini">住宅手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateYakutsuke" size="mini">役付手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateTsukin" size="mini">通勤手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateSeikin" size="mini">精勤手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateZangyo" size="mini">残業手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateOther" size="mini">{{$t("healthIns1.other")}}</el-checkbox>
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.teateOtherInput" size="mini" style="margin-left:15px;width: 185px" :placeholder="$t('healthIns1.other')" v-if="ruleForm.teateOther === true"></el-input>
                  <!-- <el-button class="el-icon-info" type="text" @click="otherAllowranceHint" v-if="ruleForm.teateOther === true"></el-button> -->
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <div>
                  <el-form-item label="事業所の所定労働時間" prop="taxOffice" class="label" style="margin-left:50px">
                    1ヶ月&nbsp;<el-input v-model="ruleForm.shoteiDay" size="mini" style="margin-right:0px;width:110px" placeholder=""></el-input>
                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1週
                    <el-input v-model="ruleForm.shoteiHour" size="mini" style="width:110px" placeholder=""></el-input>
                    時間
                    <el-input v-model="ruleForm.shoteiMinute" size="mini" style="width:110px" placeholder="00"></el-input>
                    分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1日
                    <el-input v-model="ruleForm.shoteiDayHour" size="mini" style="width:110px" placeholder=""></el-input>
                    時間
                    <el-input v-model="ruleForm.shoteiDayMinute" size="mini" style="width:110px" placeholder="00"></el-input>
                    分
                    <el-popover placement="top-start" title="所定労働時間" width="200" trigger="hover" content="所定労働時間は、法定労働時間を超えない範囲で各事業所が定めた労働時間です。 法定労働時間は４０時間（一部４４時間）/週、８時間/日を上限と定めていますので、もし、所定労働時間が４１時間/週、９時間/日となっていても、４０時間/週、８時間/日に短縮された形で解釈されます。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>

            </el-row>
          </el-collapse-item>

          <el-collapse-item title="雇用保険について" name="4">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.emp_insurance_code')" prop="empInsuranceCode" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.emp_insuranceCode" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_insurance_codeP')"></el-input>
                    <el-popover placement="top-start" title="雇用保険 事業所番号とは:" width="200" trigger="hover" content="事業所ごとに付与された11桁（4桁-6桁-1桁）の数字です。（例）12345678901「適用事業所台帳（雇用保険適用事業所設置届事業主控）」「雇用保険被保険者資格取得等確認通知書（事業主通知用）」などに記載されています。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.labor_insurance_code')" prop="laborInsuranceCode" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.laborInsuranceCode" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.labor_insurance_codeP')"></el-input>
                    <el-popover placement="top-start" title="雇用保険労働保険番号とは:" width="200" trigger="hover" content="2桁-1桁-2桁-6桁-3桁の5つの区分からなる合計14桁の数字です。過去の労働保険の概算・確定保険料申告書、労災保険申請書、労働保険の年度更新申告書などに記載されています。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.ins_amount')" prop="insAmount" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.insAmount" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.ins_amount')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.business_overview')" prop="businessOverview" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.businessOverview" size="mini" style="margin-right:0px;width:280px" placeholder="事業の種類" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.begin_day_emp')" prop="beginDayEmp">
                    <el-date-picker v-model="ruleForm.beginDayEmp" size="mini" value-format="yyyy-MM-dd" style="margin-right:10px;width:280px" type="date"></el-date-picker>
                    <el-button class="el-icon-delete" type="text" @click="open1">{{$t("general.hint")}}</el-button>
                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.begin_day_labor')" prop="beginDayLabor">
                    <el-date-picker v-model="ruleForm.beginDayLabor" size="mini" value-format="yyyy-MM-dd" style="margin-right:10px;width:280px" type="date"></el-date-picker>
                    <el-button class="el-icon-delete" type="text" @click="open1">{{$t("general.hint")}}</el-button>
                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.insamount_day')" prop="insamountDay">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.insamountDay" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.insamount_day')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item title="社会保険について" name="5">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.health_ins_code')" prop="healthInsCode" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.healthInsCode" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.health_ins_code')"></el-input>
                    <el-popover placement="top-start" title="社会保険の事業所番号:" width="200" trigger="hover" content="事業所ごとに付与された「数字 – カタカナ」の文字列です。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.emp_amount')" prop="empAmount" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.empAmount" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.health_company_num')" prop="healthCompanyNum">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.healthCompanyNum" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.health_company_num')"></el-input>
                    <el-popover placement="top-start" title="事業所整理記号:" width="200" trigger="hover" content="年金事務所から送付される「適用通知書」や「保険料納入告知額・領収済額通知書」などに記載されている番号。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="社会保険に加入する従業員数" prop="empAmount">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.empHokenAmount" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item title="社会保険に加入しない従業員について" name="6">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="役員人数" prop="yakuinNoHoken" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.yakuinNoHoken" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item v-if="ruleForm.yakuinNoHoken != ''" label="報酬" label-width="50px" prop="yakuin_hoshu" class="label">
                    <el-select v-model="ruleForm.yakuinHoshu" style="margin-left:0px; width: 90px" size="mini" placeholder="">
                      <el-option v-for="item in yakuinHoshus" :key="item.id" :label="item.name" :value="item.name">
                      </el-option>
                    </el-select>
                    &nbsp;&nbsp;&nbsp;&nbsp;常勤:
                    <el-input v-model="ruleForm.yakuinJokin" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 人&nbsp;&nbsp;&nbsp;&nbsp;非常勤:
                    <el-input v-model="ruleForm.yakuinNoJokin" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 人
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="嘱託.非常勤人数" prop="shokutakuNoJokin" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.shokutakuNoJokin" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item v-if="ruleForm.shokutakuNoJokin != ''" label="1月" label-width="50px" prop="shokutaku_no_jokin" class="label">
                    <el-input v-model="ruleForm.shokutakuNoJokin_day" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 日ぐらい&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1日:
                    <el-input v-model="ruleForm.shokutakuNoJokinTime" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 時間ぐらい
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="パート人数" prop="pato" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.pato" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item v-if="ruleForm.pato != ''" label="1月" label-width="50px" prop="pato" class="label">
                    <el-input v-model="ruleForm.patoDay" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 日ぐらい&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1日:
                    <el-input v-model="ruleForm.patoTime" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 時間ぐらい
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="アルバイト人数" prop="arubaito" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.arubaito" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item v-if="ruleForm.arubaito != ''" label="1月" label-width="50px" prop="arubaito" class="label">
                    <el-input v-model="ruleForm.arubaitoDay" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 日ぐらい&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1日:
                    <el-input v-model="ruleForm.arubaitoTime" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 時間ぐらい
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">{{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit Info -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="90%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="270px" class="demo-ruleForm" size="mini">
        <el-collapse @change="handleChange" accordion>
          <el-collapse-item :title="$t('companyInfo.office_info')" name="1" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.name1')" prop="name1" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name1" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.name1P')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.chairman')" prop="chairman" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.chairman" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.chairmanP')"></el-input>
                    <el-popover placement="top-start" title="記入方法" width="200" trigger="hover" content="代表者氏名を全角で入力してください。姓と名前の間に全角スペースを入れてください。外国籍の氏名が漢字表記ではない場合、全角アルファベット（大文字）もしくは全角カタカナで入力してください。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.chairman_code')" prop="chairmanCode" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.chairmanCode" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.company_code_example')"></el-input>
                    <el-popover placement="top-start" title="法人番号とは" width="200" trigger="hover" content="検査用数字（1桁） ＋ 会社法人等番号（12桁）を合わせた数字13桁からなる番号の事です。https://www.houjin-bangou.nta.go.jp/">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('companyInfo.establishment_date')" prop="establishmentDate" style="margin-left:50px">
                    <el-date-picker @change="DateInput11(ruleForm.establishmentDate)" v-model="ruleForm.establishmentDate" size="mini" value-format="yyyy-MM-dd" style="margin-right:10px;width:185px" placeholder="例:1996-3-20" type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput11 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('companyInfo.establishment_date')" prop="establishmentDate" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput12(ruleForm.establishmentDate)" v-model="ruleForm.establishmentDate" size="mini" style="margin-right:0px;width:185px" placeholder="例:H8/3/20" clearable=""></el-input>&nbsp;&nbsp;
                    <span> {{ dateForm.DateInput12 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != true" :label="$t('companyInfo.end_date')" prop="endDate" style="margin-left:50px">
                    <el-date-picker @change="DateInput21(ruleForm.endDate)" v-model="ruleForm.endDate" size="mini" value-format="yyyy-MM-dd" style="margin-right:10px;width:185px" placeholder="例:1996-3-20" type="date"></el-date-picker>
                    <span> {{ dateForm.DateInput21 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item v-if="dateForm.JPDateType != false" :label="$t('companyInfo.end_date')" prop="endDate" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" @change="DateInput22(ruleForm.endDate)" v-model="ruleForm.endDate" size="mini" style="margin-right:0px;width:185px" placeholder="例:H8/3/20" clearable=""></el-input>&nbsp;&nbsp;
                    <span> {{ dateForm.DateInput22 }} </span>
                    <el-checkbox v-model="dateForm.JPDateType">和暦</el-checkbox>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.capital')" prop="capital" style="margin-left:50px">
                    <el-input @change="handleToMoney" prefix-icon="el-icon-edit" v-model="ruleForm.capital" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.capital_example')"></el-input>&nbsp; 万円
                  </el-form-item>

                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.name_kn1')" prop="name_kn1">
                    <el-input v-model="ruleForm.nameKn1" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.name_kn1P')"></el-input>
                    <el-popover placement="top-start" title="記入方法" width="200" trigger="hover" content="次のとおり、略して記入してください。株式会社の場合 ➡ ｢カ 」有限会社の場合 ➡ 「ユ」合名会社の場合 ➡ 「メ」合資会社の場合➡ 「シ」それ以外の法人の場合 ➡ そのまま記入">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.chairman_ka')" prop="chairman_ka">
                    <el-input v-model="ruleForm.chairmanKa" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.chairman_kaP')"></el-input>
                    <el-popover placement="top-start" title="記入方法" width="200" trigger="hover" content="代表者氏名を全角で入力してください。姓と名前の間に全角スペースを入れてください。外国籍の氏名が漢字表記ではない場合、全角アルファベット（大文字）もしくは全角カタカナで入力してください。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <ei-col :span="24">
                <el-form-item :label="$t('companyInfo.business_overview')" prop="basicBusinessOverview" style="margin-left:50px">
                  <el-select @change="businessOverviewChanged" v-model="ruleForm.basicBusinessOverview" size="mini" style="margin-right:0px;width:280px" placeholder="入力してください" filterable clearable>
                    <el-option-group :class="groupBg" v-for="group in basicBusinessOverview" :key="group.label" :label="group.label">
                      <el-option :disabled="item.disabled" v-for="item in group.options" :key="item.value" :label="item.value" :value="item.value"></el-option>
                    </el-option-group>
                  </el-select>
                  <el-link type="primary" class="el-icon-info" :underline="false" href="https://www.chukei-news.co.jp/publication/chubunenkan-regist/type.pdf" target="_blank">業種一覧表</el-link>
                </el-form-item>
              </ei-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('companyInfo.address')" name="2">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('companyInfo.postal_code')" prop="postalCode" style="margin-left:50px">
                  <el-input @change="searchLocation" prefix-icon="el-icon-edit" v-model="ruleForm.postalCode" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.postal_code_example')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('companyInfo.address0')" prop="address0" style="margin-left:50px">
                  <!-- <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address0" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.province')"></el-input> -->
                  <el-select @change="address0Changed" v-model="ruleForm.address0" size="mini" style="margin-right:70px;width:280px" placeholder="選択">
                    <el-option v-for="item in locationList" :key="item.id" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.address1')" prop="address1" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address1" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.city')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.address2')" prop="address2" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address2" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.street')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('companyInfo.address3')" prop="address3" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address3" size="mini" style="margin-right:70px;width:280px" :placeholder="$t('companyInfo.building')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.tel')" prop="tel" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.tel" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.tel_example')"></el-input>
                  <el-popover placement="top-start" title="電話番号の書き方" width="200" trigger="hover" content="半角数字で入力してください。市外局番と市内局番、市内局番と加入者番号の間にハイフン（－）を記入してください。">
                    <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                  </el-popover>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('companyInfo.address_frgn0')" prop="addressFrgn0">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.addressFrgn0" size="mini" style="margin-right:10px;width:280px" :placeholder="$t('companyInfo.address_frgn0')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.address_frgn1')" prop="addressFrgn1">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.addressFrgn1" size="mini" style="margin-right:10px;width:280px" :placeholder="$t('companyInfo.city')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('companyInfo.address_frgn2')" prop="addressFrgn2">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.addressFrgn2" size="mini" style="margin-right:10px;width:280px" :placeholder="$t('companyInfo.street')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('companyInfo.address_frgn3')" prop="addressFrgn3">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.addressFrgn3" size="mini" style="margin-right:10px;width:280px" :placeholder="$t('companyInfo.building')"></el-input>
                </el-form-item>
                <el-form-item label="FAX" prop="fax">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.fax" size="mini" style="margin-right:0px;width:280px" placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('companyInfo.salary')" name="3">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.salary_close_day')" prop="salaryCloseDay" class="label" style="margin-left:50px">
                    <el-select :placeholder="$t('general.select')" v-model="ruleForm.salaryCloseDay" clearable style="margin-left:0px;width:280px" size="mini">
                      <el-option v-for="item in days" :key="item.daysId" :label="item.name" :value="item.name"></el-option>
                    </el-select> &nbsp;{{$t("empIns1.day")}}
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.tax_office')" prop="taxOffice" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.taxOffice" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.tax_officeP')"></el-input>
                    <el-popover placement="top-start" title="管轄の税務署とは" width="200" trigger="hover" content="所属する納税地により管轄している税務署が決められています。ご不明の場合には下記URLよりご確認下さい：https://www.nta.go.jp/about/organization/access/map.html">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.salary_day')" prop="salaryDay" class="label">
                    <el-select v-model="ruleForm.salaryMonth" clearable style="width: 110px" size="mini" :placeholder="$t('general.select')">
                      <el-option v-for="item in salaryMonths" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    &nbsp;{{$t("empIns1.month")}}&nbsp;
                    <el-select :placeholder="$t('general.select')" v-model="ruleForm.salaryDay" clearable style="width:110px" size="mini">
                      <el-option v-for="item in salaryDays" :key="item.daysId" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                    &nbsp;{{$t("empIns1.day")}}
                  </el-form-item>

                  <el-form-item prop="taxOffice" class="label">
                    <span></span>
                    <br>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="16">
                <el-form-item label="給与形態" prop="kyuyoMonth" class="label" style="margin-left:50px">
                  <el-checkbox style="margin-right:60px" v-model="ruleForm.kyuyoMonth" size="mini">月給</el-checkbox>
                  <el-checkbox style="margin-right:60px" v-model="ruleForm.kyuyoDay" size="mini">日給</el-checkbox>
                  <el-checkbox style="margin-right:60px" v-model="ruleForm.kyuyoDay_month" size="mini">日給月給</el-checkbox>
                  <el-checkbox style="margin-right:46px" v-model="ruleForm.kyuyoBuai" size="mini">歩合給</el-checkbox>
                  <el-checkbox style="margin-right:46px" v-model="ruleForm.kyuyoJikan" size="mini">時間給</el-checkbox>
                  <el-checkbox style="margin-right:46px" v-model="ruleForm.kyuyoNenpo" size="mini">年俸制</el-checkbox>
                  <el-checkbox style="margin-right:36px" v-model="ruleForm.kyuyoOther" size="mini">{{$t("healthIns1.other")}}</el-checkbox>
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.kyuyoOtherInput" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns1.other')" v-if="ruleForm.kyuyoOther === true"></el-input>
                  <!-- <el-button class="el-icon-info" type="text" @click="otherAllowranceHint" v-if="ruleForm.kyuyoOther === true"></el-button> -->
                </el-form-item>

                <el-form-item label="諸手当の種類" prop="kyuyoMonth" class="label" style="margin-left:50px">
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateKazoku" size="mini">家族手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateJutaku" size="mini">住宅手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateYakutsuke" size="mini">役付手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateTsukin" size="mini">通勤手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateSeikin" size="mini">精勤手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateZangyo" size="mini">残業手当</el-checkbox>
                  <el-checkbox style="margin-right:39px" v-model="ruleForm.teateOther" size="mini">{{$t("healthIns1.other")}}</el-checkbox>
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.teateOtherInput" size="mini" style="margin-left:15px;width: 185px" :placeholder="$t('healthIns1.other')" v-if="ruleForm.teateOther === true"></el-input>
                  <!-- <el-button class="el-icon-info" type="text" @click="otherAllowranceHint" v-if="ruleForm.teateOther === true"></el-button> -->
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <div>
                  <el-form-item label="事業所の所定労働時間" prop="taxOffice" class="label" style="margin-left:50px">
                    1月&nbsp;<el-input v-model="ruleForm.shoteiDay" size="mini" style="margin-right:0px;width:110px" placeholder=""></el-input>
                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1週
                    <el-input v-model="ruleForm.shoteiHour" size="mini" style="width:110px" placeholder=""></el-input>
                    時間
                    <el-input v-model="ruleForm.shoteiMinute" size="mini" style="width:110px" placeholder=""></el-input>
                    分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1日
                    <el-input v-model="ruleForm.shoteiDayHour" size="mini" style="width:110px" placeholder=""></el-input>
                    時間
                    <el-input v-model="ruleForm.shoteiDayMinute" size="mini" style="width:110px" placeholder=""></el-input>
                    分
                    <el-popover placement="top-start" title="所定労働時間" width="200" trigger="hover" content="所定労働時間は、法定労働時間を超えない範囲で各事業所が定めた労働時間です。 法定労働時間は４０時間（一部４４時間）/週、８時間/日を上限と定めていますので、もし、所定労働時間が４１時間/週、９時間/日となっていても、４０時間/週、８時間/日に短縮された形で解釈されます。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>

            </el-row>
          </el-collapse-item>

          <el-collapse-item title="雇用保険について" name="4">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.emp_insurance_code')" prop="empInsuranceCode" class="label" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.empInsuranceCode" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_insurance_codeP')"></el-input>
                    <el-popover placement="top-start" title="雇用保険 事業所番号とは:" width="200" trigger="hover" content="事業所ごとに付与された11桁（4桁-6桁-1桁）の数字です。（例）12345678901「適用事業所台帳（雇用保険適用事業所設置届事業主控）」「雇用保険被保険者資格取得等確認通知書（事業主通知用）」などに記載されています。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.labor_insurance_code')" prop="laborInsuranceCode" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.laborInsuranceCode" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.labor_insurance_codeP')"></el-input>
                    <el-popover placement="top-start" title="雇用保険労働保険番号とは" width="200" trigger="hover" content="2桁-1桁-2桁-6桁-3桁の5つの区分からなる合計14桁の数字です。過去の労働保険の概算・確定保険料申告書、労災保険申請書、労働保険の年度更新申告書などに記載されています。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>

                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.ins_amount')" prop="insAmount" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.insAmount" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.ins_amount')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.business_overview')" prop="businessOverview" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.businessOverview" size="mini" style="margin-right:0px;width:280px" placeholder="事業の種類" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.begin_day_emp')" prop="beginDayEmp">
                    <el-date-picker v-model="ruleForm.beginDayEmp" size="mini" value-format="yyyy-MM-dd" style="margin-right:10px;width:280px" type="date"></el-date-picker>

                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.begin_day_labor')" prop="beginDayLabor">
                    <el-date-picker v-model="ruleForm.beginDayLabor" size="mini" value-format="yyyy-MM-dd" style="margin-right:10px;width:280px" type="date"></el-date-picker>

                  </el-form-item>
                  <el-form-item :label="$t('companyInfo.insamount_day')" prop="insamountDay">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.insamountDay" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.insamount_day')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item title="社会保険について" name="5">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.health_ins_code')" prop="healthInsCode" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.healthInsCode" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.health_ins_code')"></el-input>
                    <el-popover placement="top-start" title="事業所整理記号::" width="200" trigger="hover" content="年金事務所から送付される「適用通知書」や「保険料納入告知額・領収済額通知書」などに記載されている番号。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item :label="$t('companyInfo.emp_amount')" prop="empAmount" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.empAmount" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.health_company_num')" prop="healthCompanyNum">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.healthCompanyNum" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.health_company_num')"></el-input>
                    <el-popover placement="top-start" title="社会保険の事業所番号:" width="200" trigger="hover" content="事業所ごとに付与された「数字 – カタカナ」の文字列です。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="社会保険に加入する従業員数" prop="empAmount">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.empHokenAmount" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item title="社会保険に加入しない従業員について" name="6">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="役員人数" prop="yakuinNoHoken" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.yakuinNoHoken" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item v-if="ruleForm.yakuinNoHoken != ''" label="報酬" label-width="50px" prop="yakuinHoshu" class="label">
                    <el-select v-model="ruleForm.yakuinHoshu" style="margin-left:0px; width: 90px" size="mini" placeholder="">
                      <el-option v-for="item in yakuinHoshus" :key="item.id" :label="item.name" :value="item.name">
                      </el-option>
                    </el-select>
                    &nbsp;&nbsp;&nbsp;&nbsp;常勤:
                    <el-input v-model="ruleForm.yakuinJokin" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 人&nbsp;&nbsp;&nbsp;&nbsp;非常勤:
                    <el-input v-model="ruleForm.yakuinNoJokin" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 人
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="嘱託.非常勤人数" prop="shokutakuNoJokin" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.shokutakuNoJokin" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item v-if="ruleForm.shokutakuNoJokin != ''" label="1月" label-width="50px" prop="shokutakuNoJokin" class="label">
                    <el-input v-model="ruleForm.shokutakuNoJokinDay" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 日ぐらい&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1日:
                    <el-input v-model="ruleForm.shokutakuNoJokinTime" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 時間ぐらい
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="パート人数" prop="pato" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.pato" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item v-if="ruleForm.pato != ''" label="1月" label-width="50px" prop="pato" class="label">
                    <el-input v-model="ruleForm.patoDay" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 日ぐらい&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1日:
                    <el-input v-model="ruleForm.patoTime" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 時間ぐらい
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="アルバイト人数" prop="arubaito" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.arubaito" size="mini" style="margin-right:0px;width:280px" :placeholder="$t('companyInfo.emp_amount_example')"></el-input>&nbsp; 人
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item v-if="ruleForm.arubaito != ''" label="1月" label-width="50px" prop="arubaito" class="label">
                    <el-input v-model="ruleForm.arubaitoDay" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 日ぐらい&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1日:
                    <el-input v-model="ruleForm.arubaitoTime" size="mini" style="margin-right:0px;width:90px" placeholder=""></el-input>
                    &nbsp; 時間ぐらい
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">{{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>
    <br />

    <el-dialog title="addressTest" :visible.sync="dialogAddress" width="80%" :before-close="handleClose">
      <div style="text-align:left;">
        <el-form :model="addressForm" :label-position="labelPosition" label-width="160px">
          <el-form-item label="postalCode">
            <el-input size="small" style="width:300px" v-model="addressForm.fidPostCode" @change="searchLocation"></el-input>
          </el-form-item>
          <el-form-item label="addressALL">
            <el-input size="small" style="width:500px" v-model="addressForm.fidAddress"></el-input>
          </el-form-item>
          <!-- <el-form-item label="fidAddressHira">
            <el-input size="small" style="width:500px" v-model="addressForm.fidAddressHira"></el-input>
          </el-form-item> -->
          <el-form-item label="fidAddressKana">
            <el-input size="small" style="width:500px" v-model="addressForm.fidAddressKana"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: ['1', '2', '3'],
      days: [
        {
          daysId: 0,
          name: "月末",
        },
        {
          daysId: 1,
          name: "１",
        },
        {
          daysId: 2,
          name: "２",
        },
        {
          daysId: 3,
          name: "３",
        },
        {
          daysId: 4,
          name: "４",
        },
        {
          daysId: 5,
          name: "５",
        },
        {
          daysId: 6,
          name: "６",
        },
        {
          daysId: 7,
          name: "７",
        },
        {
          daysId: 8,
          name: "８",
        },
        {
          daysId: 9,
          name: "９",
        },
        {
          daysId: 10,
          name: "１０",
        },
        {
          daysId: 11,
          name: "１１",
        },
        {
          daysId: 12,
          name: "１２",
        },
        {
          daysId: 13,
          name: "１３",
        },
        {
          daysId: 14,
          name: "１４",
        },
        {
          daysId: 15,
          name: "１５",
        },
        {
          daysId: 16,
          name: "１６",
        },
        {
          daysId: 17,
          name: "１７",
        },
        {
          daysId: 18,
          name: "１８",
        },
        {
          daysId: 19,
          name: "１９",
        },
        {
          daysId: 20,
          name: "２０",
        },
        {
          daysId: 21,
          name: "２１",
        },
        {
          daysId: 22,
          name: "２２",
        },
        {
          daysId: 23,
          name: "２３",
        },
        {
          daysId: 24,
          name: "２４",
        },
        {
          daysId: 25,
          name: "２５",
        },
        {
          daysId: 26,
          name: "２６",
        },
        {
          daysId: 27,
          name: "２７",
        },
        {
          daysId: 28,
          name: "２８",
        },
        {
          daysId: 29,
          name: "２９",
        },
        {
          daysId: 30,
          name: "３０",
        },
      ],
      salaryDays: [
        {
          daysId: 0,
          name: "月末",
        },
        {
          daysId: 1,
          name: "１",
        },
        {
          daysId: 2,
          name: "２",
        },
        {
          daysId: 3,
          name: "３",
        },
        {
          daysId: 4,
          name: "４",
        },
        {
          daysId: 5,
          name: "５",
        },
        {
          daysId: 6,
          name: "６",
        },
        {
          daysId: 7,
          name: "７",
        },
        {
          daysId: 8,
          name: "８",
        },
        {
          daysId: 9,
          name: "９",
        },
        {
          daysId: 10,
          name: "１０",
        },
        {
          daysId: 11,
          name: "１１",
        },
        {
          daysId: 12,
          name: "１２",
        },
        {
          daysId: 13,
          name: "１３",
        },
        {
          daysId: 14,
          name: "１４",
        },
        {
          daysId: 15,
          name: "１５",
        },
        {
          daysId: 16,
          name: "１６",
        },
        {
          daysId: 17,
          name: "１７",
        },
        {
          daysId: 18,
          name: "１８",
        },
        {
          daysId: 19,
          name: "１９",
        },
        {
          daysId: 20,
          name: "２０",
        },
        {
          daysId: 21,
          name: "２１",
        },
        {
          daysId: 22,
          name: "２２",
        },
        {
          daysId: 23,
          name: "２３",
        },
        {
          daysId: 24,
          name: "２４",
        },
        {
          daysId: 25,
          name: "２５",
        },
        {
          daysId: 26,
          name: "２６",
        },
        {
          daysId: 27,
          name: "２７",
        },
        {
          daysId: 28,
          name: "２８",
        },
        {
          daysId: 29,
          name: "２９",
        },
        {
          daysId: 30,
          name: "３０",
        },
      ],
      salaryMonths: [{
        value: "当",
        label: this.$t("empIns1.this_month"),
      },
      {
        value: "翌",
        label: this.$t("empIns1.next_month"),
      },
      ],
      yakuinHoshus: [{
        id: 1,
        name: "有",
      },
      {
        id: 2,
        name: "無",
      },
      ],
      labelPosition: "left",
      basicBusinessOverview: [
        {
          label: "",
          options: [
            { value: "", label: "" },
          ]
        }, {
          label: "一般の事業",
          options: [
            { value: "鉱業", label: "鉱業" },
            { value: "製造業", label: "製造業" },
            { value: "電気・ガス", label: "電気・ガス" },
            { value: "運輸・通信業", label: "運輸・通信業" },
            { value: "卸売・小売・飲食業", label: "卸売・小売・飲食業" },
            { value: "金融・保険業", label: "金融・保険業" },
            { value: "不動産業", label: "不動産業" },
            { value: "サービス業", label: "サービス業" },
            { value: "分類不能産業", label: "分類不能産業" },
          ]
        },
        {
          label: "農林水産・清酒製造の事業",
          options: [
            { value: "農林・水産", label: "農林・水産" },
            { value: "林業", label: "林業" },
            { value: "漁業", label: "漁業" },
          ]
        },
        {
          label: "建設の事業",
          options: [
            { value: "建設業", label: "建設業" },
          ]
        },
      ],
      locationList: [
        {
          value: "北海道",
          label: this.$t("NKHK.hokkaido"),
        },
        {
          value: "青森県",
          label: this.$t("NKHK.aomori"),
        },
        {
          value: "岩手県",
          label: this.$t("NKHK.iwate"),
        },
        {
          value: "宮城県",
          label: this.$t("NKHK.miyagi"),
        },
        {
          value: "秋田県",
          label: this.$t("NKHK.akita"),
        },
        {
          value: "山形県",
          label: this.$t("NKHK.yamagata"),
        },
        {
          value: "福島県",
          label: this.$t("NKHK.fukushima"),
        },
        {
          value: "茨城県",
          label: this.$t("NKHK.ibaraki"),
        },
        {
          value: "栃木県",
          label: this.$t("NKHK.tochigi"),
        },
        {
          value: "群馬県",
          label: this.$t("NKHK.gunma"),
        },
        {
          value: "埼玉県",
          label: this.$t("NKHK.saitama"),
        },
        {
          value: "千葉県",
          label: this.$t("NKHK.chiba"),
        },
        {
          value: "東京都",
          label: this.$t("NKHK.tokyo"),
        },
        {
          value: "神奈川県",
          label: this.$t("NKHK.kanagawa"),
        },
        {
          value: "新潟県",
          label: this.$t("NKHK.niigata"),
        },
        {
          value: "富山県",
          label: this.$t("NKHK.toyama"),
        },
        {
          value: "石川県",
          label: this.$t("NKHK.ishikawa"),
        },
        {
          value: "福井県",
          label: this.$t("NKHK.fukui"),
        },
        {
          value: "山梨県",
          label: this.$t("NKHK.yamanashi"),
        },
        {
          value: "長野県",
          label: this.$t("NKHK.nagano"),
        },
        {
          value: "岐阜県",
          label: this.$t("NKHK.gifu"),
        },
        {
          value: "静岡県",
          label: this.$t("NKHK.shizuoka"),
        },
        {
          value: "愛知県",
          label: this.$t("NKHK.aichi"),
        },
        {
          value: "三重県",
          label: this.$t("NKHK.mie"),
        },
        {
          value: "滋賀県",
          label: this.$t("NKHK.shiga"),
        },
        {
          value: "京都府",
          label: this.$t("NKHK.kyoto"),
        },
        {
          value: "大阪府",
          label: this.$t("NKHK.osaka"),
        },
        {
          value: "兵庫県",
          label: this.$t("NKHK.hyogo"),
        },
        {
          value: "奈良県",
          label: this.$t("NKHK.nara"),
        },
        {
          value: "和歌山県",
          label: this.$t("NKHK.wakayama"),
        },
        {
          value: "鳥取県",
          label: this.$t("NKHK.tottori"),
        },
        {
          value: "島根県",
          label: this.$t("NKHK.shimane"),
        },
        {
          value: "岡山県",
          label: this.$t("NKHK.okayama"),
        },
        {
          value: "広島県",
          label: this.$t("NKHK.hiroshima"),
        },
        {
          value: "山口県",
          label: this.$t("NKHK.yamaguchi"),
        },
        {
          value: "徳島県",
          label: this.$t("NKHK.tokushima"),
        },
        {
          value: "香川県",
          label: this.$t("NKHK.kagawa"),
        },
        {
          value: "愛媛県",
          label: this.$t("NKHK.ehime"),
        },
        {
          value: "高知県",
          label: this.$t("NKHK.kochi"),
        },
        {
          value: "福岡県",
          label: this.$t("NKHK.fukuoka"),
        },
        {
          value: "佐賀県",
          label: this.$t("NKHK.saga"),
        },
        {
          value: "長崎県",
          label: this.$t("NKHK.nagasaki"),
        },
        {
          value: "熊本県",
          label: this.$t("NKHK.kumamoto"),
        },
        {
          value: "大分県",
          label: this.$t("NKHK.oita"),
        },
        {
          value: "宮崎県",
          label: this.$t("NKHK.miyazaki"),
        },
        {
          value: "鹿児島県",
          label: this.$t("NKHK.kagoshima"),
        },
        {
          value: "沖縄県",
          label: this.$t("NKHK.okinawa"),
        },
      ],
      dateForm: {
        JPDateType: false,
        JPDate: "",
        JPDate1: "",
        JPDate2: "",
        DateInput11: "",
        DateInput12: "",
        DateInput21: "",
        DateInput22: "",
      },
      ruleForm: {
        id: "",
        nameKn1: "",
        nameKn2: "",
        nameKn3: "",
        name1: "",
        name2: "",
        name3: "",
        capital: "",
        address0: "",
        address1: "",
        address2: "",
        address3: "",
        addressFrgn0: "",
        addressFrgn1: "",
        addressFrgn2: "",
        addressFrgn3: "",
        branch: "",
        salesOffice: "",
        establishmentDate: "",
        endDate: "",
        empAmount: "",
        companyCode: "",
        number: "",
        chairman: "",
        chairmanKa: "",
        chairmanCode: "",
        empInsuranceCode: "",
        laborInsuranceCode: "",
        businessOverview: "",
        beginDayLabor: "",
        beginDayEmp: "",
        merito: "",
        salaryCloseDay: "",
        salaryDay: "",
        salaryMonth: "",
        taxOffice: "",
        postalCode: "",
        tel: "",
        basicCode: "",
        insAmount: "",
        insAmountDay: "",
        healthInsCode: "",
        healthCompanyNum: "",

        kyuyoMonth: false,
        kyuyoDay: false,
        kyuyoDayMonth: false,
        kyuyoBuai: false,
        kyuyoJikan: false,
        kyuyoNenpo: false,
        kyuyoOther: false,
        kyuyoOtherInput: "",
        teateKazoku: false,
        teateJutaku: false,
        teateYakutsuke: false,
        teateTsukin: false,
        teateSeikin: false,
        teateZangyo: false,
        teateOther: false,
        teateOtherInput: "",
        shiharaiType: "",
        empHokenAmount: "",
        yakuinNoHoken: "",
        yakuinHoshu: "",
        yakuinJokin: "",
        yakuinNoJokin: "",
        shokutakuNoJokin: "",
        shokutakuNoJokinDay: "",
        shokutakuNoJokinTime: "",
        pato: "",
        patoDay: "",
        patoTime: "",
        arubaito: "",
        arubaitoDay: "",
        arubaitoTime: "",
        shoteiDay: "",
        shoteiHour: "",
        shoteiMinute: "00",
        shoteiDayHour: "",
        shoteiDayMinute: "00",
        basicBusinessOverview: "",
        fax: "",
      },
      rules: {
        name1: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
          //全角入力正则表达式
          {
            pattern: /^[^\\x00-\\xff|\\uff61-\\uff9f|A-Za-z0-9)]+$/,
            message: this.$t("companyInfo.fillRules"),
          },
        ],
        nameKn1: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
          {
            pattern: /^[^\\x00-\\xff|\\uff61-\\uff9f|A-Za-z0-9)]+$/,
            message: this.$t("companyInfo.fillRules"),
          },
        ],
        address0: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
        addressFrgn0: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
        address1: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
        addressFrgn1: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
        address2: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
        addressFrgn2: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
        basicBusinessOverview: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
        // addressFrgn3: [
        //   {
        //     required: true,
        //     message: this.$t("companyInfo.fill"),
        //     trigger: "blur",
        //   },
        // ],
        chairman: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
          {
            pattern: /^[^\\x00-\\xff|\\uff61-\\uff9f|A-Za-z0-9)]+$/,
            message: this.$t("companyInfo.fillRules"),
          },
        ],
        chairmanKa: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
          {
            pattern: /^[^\\x00-\\xff|\\uff61-\\uff9f|A-Za-z0-9)]+$/,
            message: this.$t("companyInfo.fillRules"),
          },
        ],
        chairmanCode: [
          {
            pattern: /^[A-Za-z0-9_]+$/,
            message: this.$t("companyInfo.fillRules2"),
          },
        ],
        salaryCloseDay: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
        salaryDay: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
        postalCode: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
          {
            pattern: /^[0-9-]+$/,
            message: this.$t("companyInfo.fillRules3"),
          },
        ],
        tel: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
          {
            pattern: /^(?:|\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4}|\d{4}-\d{3}-\d{4}|\d{4}-\d{4}-\d{4})$/,
            message: this.$t("companyInfo.filltel"),
          },
        ],
        basicCode: [
          {
            required: true,
            message: this.$t("companyInfo.fill"),
            trigger: "blur",
          },
        ],
      },
      addressForm: {
        fidPostCode: "",
        fidAddress: "",
        fidAddressHira: "",
        fidAddressKana: "",
      },
      tableData: [],
      search: "",
      dialogVisible: false,
      dialogUpdate: false,
      dialogDetails: false,
      dialogAddress: false,
      pageSize: 5,
      currentPage: 1,
      total: 0,
      disablePage: false,
      loading: false,
    };
  },
  methods: {
    handleToMoney() {
      if (this.ruleForm.capital != null && this.ruleForm.capital != "") {
        if (this.ruleForm.capital.indexOf(",") != -1) {
          this.ruleForm.capital = String(this.ruleForm.capital);
          this.ruleForm.capital = Number(this.ruleForm.capital.split(",").join(""));
        }
        this.ruleForm.capital = Number(this.ruleForm.capital).toLocaleString();
      }
    },    
    DateInput11(val) {
      this.JPDate(val);
      this.dateForm.JPDate1 = this.dateForm.JPDate;
      this.dateForm.DateInput11 = this.dateForm.JPDate1;
    },
    DateInput12(val) {
      this.JPDateToEn(val);
      this.dateForm.JPDate1 = this.dateForm.JPDate;
      this.dateForm.DateInput12 = this.dateForm.JPDate1;
    },
    DateInput21(val) {
      this.JPDate(val);
      this.dateForm.JPDate2 = this.dateForm.JPDate;
      this.dateForm.DateInput21 = this.dateForm.JPDate2;
    },
    DateInput22(val) {
      this.JPDateToEn(val);
      this.dateForm.JPDate2 = this.dateForm.JPDate;
      this.dateForm.DateInput22 = this.dateForm.JPDate2;
    },
    JPDateToEn(val) {
      if (val === "") {
        this.dateForm.JPDate = "";
      }
      if (val.indexOf("/") != -1) {
        var tempDate = val.split("/");

        var JPYear = tempDate[0].substring(0, 1);
        var JPYearNum = tempDate[0].substring(1);
        var JPMonthNum = tempDate[1];
        var JPDayNum = tempDate[2];

        switch (JPYear) {
          case "S":
            JPYearNum = Number(JPYearNum) + 1925;
            JPMonthNum < 10 ? JPMonthNum = "0" + JPMonthNum : JPMonthNum;
            JPDayNum < 10 ? JPDayNum = "0" + JPDayNum : JPDayNum;
            break;
          case "H":
            JPYearNum = Number(JPYearNum) + 1988;
            JPMonthNum < 10 ? JPMonthNum = "0" + JPMonthNum : JPMonthNum;
            JPDayNum < 10 ? JPDayNum = "0" + JPDayNum : JPDayNum;
            break;
          case "R":
            JPYearNum = Number(JPYearNum) + 2018;
            JPMonthNum < 10 ? JPMonthNum = "0" + JPMonthNum : JPMonthNum;
            JPDayNum < 10 ? JPDayNum = "0" + JPDayNum : JPDayNum;
            break;
        }
        this.dateForm.JPDate = JPYearNum + "-" + JPMonthNum + "-" + JPDayNum;
      }
    },
    JPDate(val) {
      var date = new Date(val);
      var JPDate = new Intl.DateTimeFormat('ja-JP-u-ca-japanese').format(date);
      this.dateForm.JPDate = JPDate;
      if (val === null) {
        this.dateForm.JPDate = "";
      }

    },
    searchLocation(fidPostCode) {
      'use strict';
      /**
       * 郵便番号の変更イベント
       */
      // collaboflow.events.on('request.input.fidPostCode.change', function (eventData) {
      // 郵便番号を格納
      var postCode = fidPostCode.replace('-', '');
      if (postCode.length !== 7) {
        return;
      }
      var headers = {};
      var parseType = 'json';

      // 指定された郵便番号で住所を取得する
      // 郵便番号取得
      // https://api-doc.postcode-jp.com/#e0cee72981
      var apiKey = 'urbKBOFBWaFT7Xl5l8c2wQxnc6EqJHf6SkzZ5QC';
      var parameters = '?apiKey=' + apiKey;
      var url = 'https://apis.postcode-jp.com/api/v2/postcodes/' + postCode + parameters;

      this.axios({
        method: "get",
        url: url,
        headers: headers,
        parseType: parseType,
      })
        .then((response) => {

          if (response.status !== 200) {
            throw Error(response);
          }

          var searchResult = response.data;
          // 取得した住所の値を設定
          this.ruleForm.address0 = searchResult.pref;
          this.ruleForm.address1 = searchResult.city + searchResult.town;
          this.ruleForm.addressFrgn0 = searchResult.prefFullKana;
          this.ruleForm.addressFrgn1 = searchResult.cityFullKana + searchResult.townFullKana;
          //this.addressForm.fidAddress = searchResult.allAddress;
          //this.addressForm.fidAddress = searchResult.allAddress;
          //this.addressForm.fidAddress = searchResult.allAddress;
          // this.addressForm.fidAddressHira = searchResult.allAddressFullHira;
          //this.addressForm.fidAddressKana = searchResult.allAddressFullKana;
        })
        .catch(function (error) {
          // エラーリソース
          // https://api-doc.postcode-jp.com/#ec6399d678
          console.error(error);

          alert('住所の検索に失敗しました。自分入力してください！');
          return false;
        });
      // });
    },
    businessOverviewChanged() {
      switch (this.ruleForm.basicBusinessOverview) {
        case "鉱業":
          this.ruleForm.businessOverview = "一般の事業";
          break;
        case "製造業":
          this.ruleForm.businessOverview = "一般の事業";
          break;
        case "電気・ガス":
          this.ruleForm.businessOverview = "一般の事業";
          break;
        case "運輸・通信業":
          this.ruleForm.businessOverview = "一般の事業";
          break;
        case "卸売・小売・飲食業":
          this.ruleForm.businessOverview = "一般の事業";
          break;
        case "金融・保険業":
          this.ruleForm.businessOverview = "一般の事業";
          break;
        case "不動産業":
          this.ruleForm.businessOverview = "一般の事業";
          break;
        case "サービス業":
          this.ruleForm.businessOverview = "一般の事業";
          break;
        case "分類不能産業":
          this.ruleForm.businessOverview = "一般の事業";
          break;
        case "農林・水産":
          this.ruleForm.businessOverview = "農林水産・清酒製造の事業";
          break;
        case "林業":
          this.ruleForm.businessOverview = "農林水産・清酒製造の事業";
          break;
        case "漁業":
          this.ruleForm.businessOverview = "農林水産・清酒製造の事業";
          break;
        case "建設業":
          this.ruleForm.businessOverview = "建設の事業";
          break;
        case "":
          this.ruleForm.businessOverview = "";
      }
    },
    address0Changed() {
      switch (this.ruleForm.address0) {
        case "北海道":
          this.ruleForm.addressFrgn0 = "ホッカイドウ";
          break;
        case "青森県":
          this.ruleForm.addressFrgn0 = "アオモリケン";
          break;
        case "岩手県":
          this.ruleForm.addressFrgn0 = "イワテケン";
          break;
        case "宮城県":
          this.ruleForm.addressFrgn0 = "ミヤギケン";
          break;
        case "秋田県":
          this.ruleForm.addressFrgn0 = "アキタケン";
          break;
        case "山形県":
          this.ruleForm.addressFrgn0 = "ヤマガタケン";
          break;
        case "福島県":
          this.ruleForm.addressFrgn0 = "フクシマケン";
          break;
        case "茨城県":
          this.ruleForm.addressFrgn0 = "イバラキケン";
          break;
        case "栃木県":
          this.ruleForm.addressFrgn0 = "トチギケン";
          break;
        case "群馬県":
          this.ruleForm.addressFrgn0 = "グンマケン";
          break;
        case "埼玉県":
          this.ruleForm.addressFrgn0 = "サイタマケン";
          break;
        case "千葉県":
          this.ruleForm.addressFrgn0 = "チバケン";
          break;
        case "東京都":
          this.ruleForm.addressFrgn0 = "トウキョウト";
          break;
        case "神奈川県":
          this.ruleForm.addressFrgn0 = "カナガワケン";
          break;
        case "新潟県":
          this.ruleForm.addressFrgn0 = "ニイガタケン";
          break;
        case "富山県":
          this.ruleForm.addressFrgn0 = "トヤマケン";
          break;
        case "石川県":
          this.ruleForm.addressFrgn0 = "イシカワケン";
          break;
        case "福井県":
          this.ruleForm.addressFrgn0 = "フクイケン";
          break;
        case "山梨県":
          this.ruleForm.addressFrgn0 = "ヤマナシケン";
          break;
        case "長野県":
          this.ruleForm.addressFrgn0 = "ナガノケン";
          break;
        case "岐阜県":
          this.ruleForm.addressFrgn0 = "ギフケン";
          break;
        case "静岡県":
          this.ruleForm.addressFrgn0 = "シズオカケン";
          break;
        case "愛知県":
          this.ruleForm.addressFrgn0 = "アイチケン";
          break;
        case "三重県":
          this.ruleForm.addressFrgn0 = "ミエケン";
          break;
        case "滋賀県":
          this.ruleForm.addressFrgn0 = "シガケン";
          break;
        case "京都府":
          this.ruleForm.addressFrgn0 = "キョウトフ";
          break;
        case "大阪府":
          this.ruleForm.addressFrgn0 = "オオサカフ";
          break;
        case "兵庫県":
          this.ruleForm.addressFrgn0 = "ヒョウゴケン";
          break;
        case "奈良県":
          this.ruleForm.addressFrgn0 = "ナラケン";
          break;
        case "和歌山県":
          this.ruleForm.addressFrgn0 = "ワカヤマケン";
          break;
        case "鳥取県":
          this.ruleForm.addressFrgn0 = "トットリケン";
          break;
        case "島根県":
          this.ruleForm.addressFrgn0 = "シマネケン";
          break;
        case "岡山県":
          this.ruleForm.addressFrgn0 = "オカヤマケン";
          break;
        case "広島県":
          this.ruleForm.addressFrgn0 = "ヒロシマケン";
          break;
        case "山口県":
          this.ruleForm.addressFrgn0 = "ヤマグチケン";
          break;
        case "徳島県":
          this.ruleForm.addressFrgn0 = "トクシマケン";
          break;
        case "香川県":
          this.ruleForm.addressFrgn0 = "カガワケン";
          break;
        case "愛媛県":
          this.ruleForm.addressFrgn0 = "エヒメケン";
          break;
        case "高知県":
          this.ruleForm.addressFrgn0 = "コウチケン";
          break;
        case "福岡県":
          this.ruleForm.addressFrgn0 = "フクオカケン";
          break;
        case "佐賀県":
          this.ruleForm.addressFrgn0 = "サガケン";
          break;
        case "長崎県":
          this.ruleForm.addressFrgn0 = "ナガサキケン";
          break;
        case "熊本県":
          this.ruleForm.addressFrgn0 = "クマモトケン";
          break;
        case "大分県":
          this.ruleForm.addressFrgn0 = "オオイタケン";
          break;
        case "宮崎県":
          this.ruleForm.addressFrgn0 = "ミヤザキケン";
          break;
        case "鹿児島県":
          this.ruleForm.addressFrgn0 = "カゴシマケン";
          break;
        case "沖縄県":
          this.ruleForm.addressFrgn0 = "オキナワケン";
      }

    },
    handleDelete(index, row) {
      console.log(index, row);
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteComInfo",
            data: postData,
          })
            .then((response) => {
              this.getPages();
              this.currentPage = 1;
              this.axios
                .post("/pageComInfo")
                .then((response) => {
                  this.tableData = response.data;
                })
                .catch((error) => {
                  console.log(error);
                });
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed"),
              });
              console.log(response);
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.delete_failed"),
              });
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },
    handleEdit(index, row) {
      this.dialogUpdate = true;
      this.ruleForm = Object.assign({}, row);
      this.dateForm.JPDateType = false;
      this.ruleForm.capital = this.ruleForm.capital.toLocaleString();
    },
    handleDetails(index, row) {
      this.dialogDetails = true;
      this.ruleForm = Object.assign({}, row);
      this.ruleForm.capital = this.ruleForm.capital.toLocaleString();
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          this.emptyUserData();
          done();
        })
        .catch((_) => { });
    },
    handleCurrentChange() {
      console.log(`this.$t("general.current_page"): ${this.currentPage}`);
      let postData = this.qs.stringify({
        page: this.currentPage,
      });
      this.axios({
        method: "post",
        url: "/pageComInfo",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
          this.tableData[0].capital = Number(response.data[0].capital).toLocaleString();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    s1_cancel(ruleForm) {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.dialogDetails = false;
      this.emptyUserData();
      this.$refs[ruleForm].resetFields();
    },
    cancel() {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.dialogDetails = false;
      this.emptyUserData();
    },
    emptyUserData() {
        this.dateForm.JPDateType = false,
        this.dateForm.JPDate = "",
        this.dateForm.DateInput11 = "",
        this.dateForm.DateInput12 = "",
        this.dateForm.DateInput21 = "",
        this.dateForm.DateInput22 = "",
        this.ruleForm = {
          id: "",
          nameKn1: "",
          nameKn2: "",
          nameKn3: "",
          name1: "",
          name2: "",
          name3: "",
          capital: "",
          address0: "",
          address1: "",
          address2: "",
          address3: "",
          addressFrgn0: "",
          addressFrgn1: "",
          addressFrgn2: "",
          addressFrgn3: "",
          branch: "",
          salesOffice: "",
          establishmentDate: "",
          endDate: "",
          empAmount: "",
          companyCode: "",
          number: "",
          chairman: "",
          chairmanKa: "",
          chairmanCode: "",
          empInsuranceCode: "",
          laborInsuranceCode: "",
          businessOverview: "",
          beginDayLabor: "",
          beginDayEmp: "",
          merito: "",
          salaryCloseDay: "",
          salaryDay: "",
          salaryMonth: "",
          taxOffice: "",
          postalCode: "",
          tel: "",
          basicCode: "",
          insAmount: "",
          insamountDay: "",
          healthInsCode: "",
          healthCompanyNum: "",

          kyuyoMonth: false,
          kyuyoDay: false,
          kyuyoDayMonth: false,
          kyuyoBuai: false,
          kyuyoJikan: false,
          kyuyoNenpo: false,
          kyuyoOther: false,
          kyuyoOtherInput: "",
          teateKazoku: false,
          teateJutaku: false,
          teateYakutsuke: false,
          teateTsukin: false,
          teateSeikin: false,
          teateZangyo: false,
          teateOther: false,
          teateOtherInput: "",
          shiharaiType: "",
          empHokenAmount: "",
          yakuinNoHoken: "",
          yakuinHoshu: "",
          yakuinJokin: "",
          yakuinNoJokin: "",
          shokutakuNoJokin: "",
          shokutakuNoJokinDay: "",
          shokutakuNoJokinTime: "",
          pato: "",
          patoDay: "",
          patoTime: "",
          arubaito: "",
          arubaitoDay: "",
          arubaitoTime: "",
          shoteiDay: "",
          shoteiHour: "",
          shoteiMinute: "",
          shoteiDayHour: "",
          shoteiDayMinute: "",
          basicBusinessOverview: "",
          fax: "",
        };
    },
    addUser(ruleForm) {
      this.ruleForm.capital = String(this.ruleForm.capital);
      this.ruleForm.capital = Number(this.ruleForm.capital.split(",").join(""));
      if (this.ruleForm.establishmentDate != null && this.ruleForm.establishmentDate != "") {
        if (this.ruleForm.establishmentDate.indexOf("/") != -1) {
          this.ruleForm.establishmentDate = this.dateForm.JPDate1;
        }
      }
      if (this.ruleForm.endDate != null && this.ruleForm.endDate != "") {
        if (this.ruleForm.endDate.indexOf("/") != -1) {
          this.ruleForm.endDate = this.dateForm.JPDate2;
        }
      }
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            nameKn1: this.ruleForm.nameKn1,
            nameKn2: this.ruleForm.nameKn2,
            nameKn3: this.ruleForm.nameKn3,
            name1: this.ruleForm.name1,
            name2: this.ruleForm.name2,
            name3: this.ruleForm.name3,
            capital: this.ruleForm.capital,
            address0: this.ruleForm.address0,
            address1: this.ruleForm.address1,
            address2: this.ruleForm.address2,
            address3: this.ruleForm.address3,
            addressFrgn0: this.ruleForm.addressFrgn0,
            addressFrgn1: this.ruleForm.addressFrgn1,
            addressFrgn2: this.ruleForm.addressFrgn2,
            addressFrgn3: this.ruleForm.addressFrgn3,
            branch: this.ruleForm.branch,
            salesOffice: this.ruleForm.salesOffice,
            establishmentDate: this.ruleForm.establishmentDate,
            endDate: this.ruleForm.endDate,
            empAmount: this.ruleForm.empAmount,
            companyCode: this.ruleForm.companyCode,
            chairman: this.ruleForm.chairman,
            chairmanKa: this.ruleForm.chairmanKa,
            chairmanCode: this.ruleForm.chairmanCode,
            empInsuranceCode: this.ruleForm.empInsuranceCode,
            laborInsuranceCode: this.ruleForm.laborInsuranceCode,
            businessOverview: this.ruleForm.businessOverview,
            beginDayLabor: this.ruleForm.beginDayLabor,
            beginDayEmp: this.ruleForm.beginDayEmp,
            merito: this.ruleForm.merito,
            salaryCloseDay: this.ruleForm.salaryCloseDay,
            salaryDay: this.ruleForm.salaryDay,
            salaryMonth: this.ruleForm.salaryMonth,
            taxOffice: this.ruleForm.taxOffice,
            postalCode: this.ruleForm.postalCode,
            tel: this.ruleForm.tel,
            basicCode: this.ruleForm.basicCode,
            insAmount: this.ruleForm.insAmount,
            insamountDay: this.ruleForm.insamountDay,
            healthInsCode: this.ruleForm.healthInsCode,
            healthCompanyNum: this.ruleForm.healthCompanyNum,

            kyuyoMonth: this.ruleForm.kyuyoMonth,
            kyuyoDay: this.ruleForm.kyuyoDay,
            kyuyoDayMonth: this.ruleForm.kyuyoDayMonth,
            kyuyoBuai: this.ruleForm.kyuyoBuai,
            kyuyoJikan: this.ruleForm.kyuyoJikan,
            kyuyoNenpo: this.ruleForm.kyuyoNenpo,
            kyuyoOther: this.ruleForm.kyuyoOther,
            kyuyoOtherInput: this.ruleForm.kyuyoOtherInput,
            teateKazoku: this.ruleForm.teateKazoku,
            teateJutaku: this.ruleForm.teateJutaku,
            teateYakutsuke: this.ruleForm.teateYakutsuke,
            teateTsukin: this.ruleForm.teateTsukin,
            teateSeikin: this.ruleForm.teateSeikin,
            teateZangyo: this.ruleForm.teateZangyo,
            teateOther: this.ruleForm.teateOther,
            teateOtherInput: this.ruleForm.teateOtherInput,
            shiharaiType: this.ruleForm.shiharaiType,
            empHokenAmount: this.ruleForm.empHokenAmount,
            yakuinNoHoken: this.ruleForm.yakuinNoHoken,
            yakuinHoshu: this.ruleForm.yakuinHoshu,
            yakuinJokin: this.ruleForm.yakuinJokin,
            yakuinNoJokin: this.ruleForm.yakuinNoJokin,
            shokutakuNoJokin: this.ruleForm.shokutakuNoJokin,
            shokutakuNoJokinDay: this.ruleForm.shokutakuNoJokinDay,
            shokutakuNoJokinTime: this.ruleForm.shokutakuNoJokinTime,
            pato: this.ruleForm.pato,
            patoDay: this.ruleForm.patoDay,
            patoTime: this.ruleForm.patoTime,
            arubaito: this.ruleForm.arubaito,
            arubaitoDay: this.ruleForm.arubaitoDay,
            arubaitoTime: this.ruleForm.arubaitoTime,
            shoteiDay: this.ruleForm.shoteiDay,
            shoteiHour: this.ruleForm.shoteiHour,
            shoteiMinute: this.ruleForm.shoteiMinute,
            shoteiDayHour: this.ruleForm.shoteiDayHour,
            shoteiDayMinute: this.ruleForm.shoteiDayMinute,
            basicBusinessOverview: this.ruleForm.basicBusinessOverview,
            fax: this.ruleForm.fax
          });
          this.axios({
            method: "post",
            url: "/insertComInfo",
            data: postData,
          })
            .then((response) => {
              if (response.data.id == null) {
                this.$message({
                  type: "warning",
                  message: this.$t("companyInfo.cant"),
                });
                this.axios
                  .post("/pageComInfo")
                  .then((response) => {
                    this.tableData = response.data;
                    this.tableData[0].capital = Number(response.data[0].capital).toLocaleString();
                  })
                  .catch((error) => {
                  });
                
              } else {
                this.axios
                  .post("/pageComInfo")
                  .then((response) => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed"),
                    });
                  })
                  .catch((error) => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed"),
                    });
                  });
              }
              this.getPages();
              this.dialogVisible = false;
              this.emptyUserData();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    updateUser(ruleForm) {
      this.ruleForm.capital = String(this.ruleForm.capital);
      this.ruleForm.capital = Number(this.ruleForm.capital.split(",").join(""));      
      if (this.ruleForm.establishmentDate != null && this.ruleForm.establishmentDate != "") {
        if (this.ruleForm.establishmentDate.indexOf("/") != -1) {
          this.ruleForm.establishmentDate = this.dateForm.JPDate1;
        }
      }
      if (this.ruleForm.endDate != null && this.ruleForm.endDate != "") {
        if (this.ruleForm.endDate.indexOf("/") != -1) {
          this.ruleForm.endDate = this.dateForm.JPDate2;
        }
      }
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.ruleForm.id,
            nameKn1: this.ruleForm.nameKn1,
            nameKn2: this.ruleForm.nameKn2,
            nameKn3: this.ruleForm.nameKn3,
            name1: this.ruleForm.name1,
            name2: this.ruleForm.name2,
            name3: this.ruleForm.name3,
            capital: this.ruleForm.capital,
            address0: this.ruleForm.address0,
            address1: this.ruleForm.address1,
            address2: this.ruleForm.address2,
            address3: this.ruleForm.address3,
            addressFrgn0: this.ruleForm.addressFrgn0,
            addressFrgn1: this.ruleForm.addressFrgn1,
            addressFrgn2: this.ruleForm.addressFrgn2,
            addressFrgn3: this.ruleForm.addressFrgn3,
            branch: this.ruleForm.branch,
            salesOffice: this.ruleForm.salesOffice,
            establishmentDate: this.ruleForm.establishmentDate,
            endDate: this.ruleForm.endDate,
            empAmount: this.ruleForm.empAmount,
            companyCode: this.ruleForm.companyCode,
            chairman: this.ruleForm.chairman,
            chairmanKa: this.ruleForm.chairmanKa,
            chairmanCode: this.ruleForm.chairmanCode,
            empInsuranceCode: this.ruleForm.empInsuranceCode,
            laborInsuranceCode: this.ruleForm.laborInsuranceCode,
            businessOverview: this.ruleForm.businessOverview,
            beginDayLabor: this.ruleForm.beginDayLabor,
            beginDayEmp: this.ruleForm.beginDayEmp,
            merito: this.ruleForm.merito,
            salaryCloseDay: this.ruleForm.salaryCloseDay,
            salaryDay: this.ruleForm.salaryDay,
            salaryMonth: this.ruleForm.salaryMonth,
            taxOffice: this.ruleForm.taxOffice,
            postalCode: this.ruleForm.postalCode,
            tel: this.ruleForm.tel,
            basicCode: this.ruleForm.basicCode,
            insAmount: this.ruleForm.insAmount,
            insamountDay: this.ruleForm.insamountDay,
            healthInsCode: this.ruleForm.healthInsCode,
            healthCompanyNum: this.ruleForm.healthCompanyNum,

            kyuyoMonth: this.ruleForm.kyuyoMonth,
            kyuyoDay: this.ruleForm.kyuyoDay,
            kyuyoDayMonth: this.ruleForm.kyuyoDayMonth,
            kyuyoBuai: this.ruleForm.kyuyoBuai,
            kyuyoJikan: this.ruleForm.kyuyoJikan,
            kyuyoNenpo: this.ruleForm.kyuyoNenpo,
            kyuyoOther: this.ruleForm.kyuyoOther,
            kyuyoOtherInput: this.ruleForm.kyuyoOtherInput,
            teateKazoku: this.ruleForm.teateKazoku,
            teateJutaku: this.ruleForm.teateJutaku,
            teateYakutsuke: this.ruleForm.teateYakutsuke,
            teateTsukin: this.ruleForm.teateTsukin,
            teateSeikin: this.ruleForm.teateSeikin,
            teateZangyo: this.ruleForm.teateZangyo,
            teateOther: this.ruleForm.teateOther,
            teateOtherInput: this.ruleForm.teateOtherInput,
            shiharaiType: this.ruleForm.shiharaiType,
            empHokenAmount: this.ruleForm.empHokenAmount,
            yakuinNoHoken: this.ruleForm.yakuinNoHoken,
            yakuinHoshu: this.ruleForm.yakuinHoshu,
            yakuinJokin: this.ruleForm.yakuinJokin,
            yakuinNoJokin: this.ruleForm.yakuinNoJokin,
            shokutakuNoJokin: this.ruleForm.shokutakuNoJokin,
            shokutakuNoJokinDay: this.ruleForm.shokutakuNoJokinDay,
            shokutakuNoJokinTime: this.ruleForm.shokutakuNoJokinTime,
            pato: this.ruleForm.pato,
            patoDay: this.ruleForm.patoDay,
            patoTime: this.ruleForm.patoTime,
            arubaito: this.ruleForm.arubaito,
            arubaitoDay: this.ruleForm.arubaitoDay,
            arubaitoTime: this.ruleForm.arubaitoTime,
            shoteiDay: this.ruleForm.shoteiDay,
            shoteiHour: this.ruleForm.shoteiHour,
            shoteiMinute: this.ruleForm.shoteiMinute,
            shoteiDayHour: this.ruleForm.shoteiDayHour,
            shoteiDayMinute: this.ruleForm.shoteiDayMinute,
            basicBusinessOverview: this.ruleForm.basicBusinessOverview,
            fax: this.ruleForm.fax,
          });
          this.axios({
            method: "post",
            url: "/updateComInfo",
            data: postData,
          })
            .then((response) => {
              this.handleCurrentChange();
              this.s1_cancel(ruleForm);
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    onSearch() {
      let postData = this.qs.stringify({
        name: this.search,
      });
      this.axios({
        method: "post",
        url: "/ListByNameComInfo",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
          this.disablePage = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPages() {
      this.axios
        .post("/rowsComInfo")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshData() {
      location.reload();
    },
  },
  created() {
    this.axios
      .post("/pageComInfo")
      .then((response) => {
        this.tableData = response.data;
        this.tableData[0].capital = Number(response.data[0].capital).toLocaleString();
      })
      .catch((error) => {
        console.log(error);
      });

    this.axios
      .post("/rowsComInfo")
      .then((response) => {
        this.total = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}

.btn-custom-confirm {
  width: 90px;
}
</style>
<style scoped>
.el-icon-delete {
  visibility: hidden;
}

.style1 {
  margin-right: 60px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/CompanyInfo.vue